<ion-item lines="none" [color]="color" class="ion-text-center">
  <ion-button class="ion-no-margin" slot="end" fill="clear" (click)="closed.emit()">
    <ion-icon size="small" color="dark" name="close" slot="end"></ion-icon>
  </ion-button>
  <ion-note color="dark">{{ text }}</ion-note>
</ion-item>
